import { useConfirm } from 'primevue/useconfirm';
import { useI18n } from 'vue-i18n';

/**
 * The dashboard's one way to ask "are you sure?": resolves true on accept.
 * Rendered by the single <ConfirmDialog> in pages/index/index.vue, never the
 * browser's own confirm(). `danger` makes the accept button rose.
 *
 * The header is the action as a question ("2 tickets annuleren?"), the other button "Terug".
 * The accept button always names what it does ("Tickets inchecken", "Vervangen"), never a bare
 * yes or "confirm": a deletion may leave it out (it says "Verwijderen"), anything else must pass it.
 */
type ConfirmOptions = { header?: string } & ({ accept: string; danger?: boolean } | { accept?: string; danger: true });
export function useConfirmAction() {
  const confirm = useConfirm();
  const { t } = useI18n();
  return (message: string, opts: ConfirmOptions) =>
    new Promise<boolean>((resolve) => {
      confirm.require({
        message,
        header: opts.header ?? `${opts.accept ?? t('delete')}?`,
        acceptLabel: opts.accept ?? t('delete'),
        rejectLabel: t('back'),
        acceptProps: opts.danger ? { severity: 'danger' } : {},
        rejectProps: { severity: 'secondary', text: true },
        accept: () => resolve(true),
        reject: () => resolve(false),
        onHide: () => resolve(false),
      });
    });
}
